<template>
  <v-menu class="abf-owner-select">
    <template v-slot:activator="{ on: menu }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <abf-owner-avatar
            @click.native.stop.prevent
            :size="size"
            :user="selectedOwner"
            :activator="{ ...tooltip, ...menu }"
          ></abf-owner-avatar>
        </template>
        <span>Owner: {{ ownerName }}</span>
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item
        v-for="owner in sortedOwners"
        :key="owner.id"
        @click="$emit('update:selected', owner.id)"
        :class="{ selected: owner.id === selected }"
      >
        <v-list-item-avatar>
          <abf-owner-avatar :user="owner"></abf-owner-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="owner.full_name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import AbfOwnerAvatar from './AbfOwnerAvatar';
import { mapGetters } from 'vuex';
import _ from 'lodash';
const assetURL = 'https://s3-eu-west-1.amazonaws.com/media.alternativebusinessfunding.co.uk/public/avatars';
export default {
  name: 'AbfOwnerSelect',
  components: {
    AbfOwnerAvatar
  },
  props: {
    owners: {
      required: true
    },
    selected: {
      default: null
    },
    size: {
      default: '33'
    }
  },
  computed: {
    ...mapGetters(['UserHasRole']),
    ownerName() {
      return this.selectedOwner ? this.selectedOwner.full_name : 'Not assigned';
    },
    sortedOwners() {
      let owners = this.owners
        .map(({ id, full_name, roles }) => ({
          id,
          full_name,
          roles,
          url: `${assetURL}/${id}.png`
        }))
        .sort((a, b) => a.full_name.localeCompare(b.full_name));
      if (this.UserHasRole('Property Broker')) {
        owners = _.filter(owners, owner => owner.roles.includes('Property Broker'));
      }
      owners.push({
        id: null,
        full_name: 'Not Assigned',
        roles: [],
        url: null
      });
      return owners;
    },
    selectedOwner() {
      return this.owners.find(owner => owner.id === this.selected);
    }
  }
};
</script>

<style lang="scss" scoped>
.v-list div.selected {
  background-color: #b08faf;
}
</style>
